import { RootState } from '../../redux/store';

export const selectToken = (state: RootState): string | null => state.authState.token;
export const selectTenantId = (state: RootState): string | null => state.authState.tenantId;
export const selectUserId = (state: RootState): string | null => state.authState.userId;